export const BLOG = {
  POST: '/appearance/blog/blog-post',
  CATEGORY: '/appearance/blog/blog-category',
  BY_SLUG: '/appearance/blog/blog-post-by-slug',
}
